import axios from "axios";
import { API_URL } from "../../constants";

export const GetAuthToken = async (ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    try {
        let res = await axios.get("https://kycapi.microvistatech.com/api/auth/generateauthtoken?tokenID=ATRWBJJE&tokenSecret=V2F6CLYCUVQ2", {}, {
            // headers: {
            //     'Authorization': "Bearer " + token,
            // }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}